<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import AssignmentResource from '../resources/assignment'
import { assignmentStatusOptions } from '../resources/formsets/assignment'

export default Vue.extend({
    components: {
        AgGridVue,
    },
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            assignmentColumnDefs: [
                {
                    field: 'id',
                    headerName: 'Assignment ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'employee_id',
                    headerName: 'Employee ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.employee_id
                    },
                },
                {
                    field: 'entity_id',
                    headerName: 'Entity',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.get('entity_id.name')
                    },
                },
                {
                    field: 'job_title_id',
                    headerName: 'job_title',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.get('job_title_id.name')
                    },
                },
                {
                    field: 'loanout_status',
                    headerName: 'Loanout Status',
                    sortable: true,
                    valueGetter: (params) => {
                        if (params.data.attributes.loanout_status) return 'Active'
                        else return 'InActive'
                    },
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    sortable: true,
                    valueGetter: (params) => {
                        return this.formsets.assignmentStatusOptions[params.data.attributes.status].text
                    },
                },
                {
                    field: 'rate',
                    headerName: 'Rate',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.rate
                    },
                },
                {
                    field: 'rate_unit_id',
                    headerName: 'Rate Unit',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.get('rate_unit_id.propay_id')
                    },
                },
                {
                    field: 'guaranteed_hours',
                    headerName: 'Guaranteed hours',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.guaranteed_hours
                    },
                },
                {
                    field: 'guaranteed_hours_unit_id',
                    headerName: 'Guaranteed hours Unit',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.guaranteed_hours_unit_id
                    },
                },
                {
                    field: 'time_added',
                    headerName: 'Time Added',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.time_added
                    },
                },
                {
                    field: 'time_updated',
                    headerName: 'Time Updated',
                    sortable: true,
                    valueGetter: (params) => {
                        return params.data.attributes.time_updated
                    },
                },
            ],
        }
    },
    computed: {
        resources() {
            return {
                AssignmentResource,
            }
        },
        formsets() {
            return {
                assignmentStatusOptions,
            }
        },
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },

        selectAssignment(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },
    },
})
</script>

<template>
    <div>
        <h4>Shows Assignment Grid</h4>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="assignmentColumnDefs" :row-data="rowData" @grid-ready="onGridReady" @row-clicked="selectAssignment" />
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
